
export default function without<T>(array: T[], values: T[]): T[] {
    return Array.from(new Set(array.filter((value) => {
        return !values.includes(value);
    })));
}
